import { Dispatch, SetStateAction } from 'react'
import * as yup from 'yup'
import { User } from 'types'

export type FormData = {
  phoneNumber: string
}

export type PhoneFormProps = {
  user: User
  affiliateId: number
  defaultValue?: string
  updateLor?: boolean
  update?: (newValue) => void
  setIsEditing?: Dispatch<SetStateAction<boolean>>
}

export const schema = yup
  .object()
  .shape({
    phoneNumber: yup
      .string()
      .required('Phone Number is Required')
      .max(15, 'Phone number must be at most 15 characters'),
  })
  .required()
